/* eslint-disable class-methods-use-this */
/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * author Satyaki Bose
 */


import Framework, { BaseService } from '@greenville/framework';
import { PDP_SERVICE_FETCHED, PDP_SERVICE_REQUESTED, PDP_SERVICE_ERROR } from '../../../common/constants';

export default class PDPRedirectService extends BaseService {
  constructor() {
    super(PDP_SERVICE_REQUESTED, PDP_SERVICE_FETCHED);
    this.error = false;
  }

  /**
   * Handle the event and trigger the API call
   *
   * @param {string} eventName
   * @param {Object} event
   * @returns {Promise}
   */
  handleEvent(eventName, event) {
    if (event && event.data && event.data.courseId) {
      return this.getClient('marinV2').get(`/pdpredirect/course/${event.data.courseId}`);
    }
    return Promise.reject(new Error('Invalid event or courseId'));
  }

  /**
   * Handle the API response
   *
   * @param {Object} response
   */
  handleResponse(response) {
    const { data } = response;
    if (data) {
      Framework.getEventManager().publish(PDP_SERVICE_FETCHED, data);
      this.error = false;
    }
  }

  /**
   * Handle API errors
   *
   * @param {Object} error
   */
  handleError(error) {
    this.error = true;
    Framework.getEventManager().publish(PDP_SERVICE_ERROR);
    console.error('PDP Redirect Service Error:', error);
  }
}
